import {Component, Input, OnInit} from '@angular/core';
import {OrderService} from '../../../shared/services/order.service';
import {CartInterface} from '../../../shared/models/cart/cart.interface';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {LoadingService} from '../../../shared/services/loading.service';
import {PlatformContextService} from '../../../shared/services/context';

@Component({
  selector: 'core-order-note',
  template: `
      <form [formGroup]="form" (ngSubmit)="submit()" class="cardContent-sep">
          <ion-item>
              <ion-label stacked color="primary">Remarque publique</ion-label>
              <ion-textarea rows="4" formControlName="remarquePublic" mode="ios" type="text"
                            [readonly]="updatable"></ion-textarea>
          </ion-item>
          <ion-item *ngIf="true === platformContextService.isElu()">
              <ion-label stacked color="primary">Remarque privée</ion-label>
              <ion-textarea rows="4" formControlName="remarquePrive" mode="ios" type="text"></ion-textarea>
          </ion-item>

          <ion-row class="fullHeight-bottom" padding *ngIf="false === updatable">
              <ion-col>
                  <button ion-button type="submit" ion-button full large text-uppercase class="secondary">Valider
                  </button>
              </ion-col>
          </ion-row>
      </form>
  `
})
export class OrderNoteComponent implements OnInit {
  @Input() public order: CartInterface;
  @Input() public updatable: boolean = false;

  private form: FormGroup;

  constructor(
    readonly orderService: OrderService,
    readonly formBuilder: FormBuilder,
    readonly loadingService: LoadingService,
    readonly platformContextService: PlatformContextService
  ) {
  }

  ngOnInit(): void {
    if (this.order === null || this.order === undefined) {
      throw new Error('Required parameter order was null or undefined when calling initialize OrderNoteComponent.');
    }

    this.buildForm();
  }

  private submit(): void {
    this.loadingService.start();
    this.orderService.partialUpdate(this.order, this.form.value).subscribe(() => this.loadingService.end());
  }

  private buildForm(): void {
    this.form = this.formBuilder.group({
      remarquePublic: this.order.remarquePublic
    });

    if (true === this.platformContextService.isElu()) {
      this.form.addControl('remarquePrive', new FormControl(this.order.remarquePrive));
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/order/note/order-note.component.ts